class ShopMenuTabs extends HTMLElement {
  constructor() {
    super();

    this.pills = Array.from(
      this.querySelectorAll('.shop-menu-tabs__pill')
    );

    this.panels = Array.from(
      this.querySelectorAll('.shop-menu-tabs__panel')
    );

    this.pills.forEach((pill) => {
      pill.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.activate(pill.dataset.shopTab);
      }, true);
    });
  }

  activate(id) {
    this.pills.forEach((pill) => {
      const isActive = pill.dataset.shopTab === id;

      pill.classList.toggle('is-active', isActive);
      pill.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      panel.classList.toggle(
        'is-active',
        panel.dataset.shopPanel === id
      );
    });
  }
}

if (!customElements.get('shop-menu-tabs')) {
  customElements.define('shop-menu-tabs', ShopMenuTabs);
}